var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-3801 -2738.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text-height-solid",
    d: "M1.432,32A1.43,1.43,0,0,0,0,33.432V36.3a1.432,1.432,0,1,0,2.864,0V34.864H5.728v7.384H4.3a1.432,1.432,0,0,0,0,2.864h5.728a1.432,1.432,0,1,0,0-2.864H8.592V34.864h2.864V36.3a1.432,1.432,0,1,0,2.864,0V33.432A1.43,1.43,0,0,0,12.887,32H1.432Z",
    transform: "translate(3801.031 2706.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 14,
    height: 3,
    rx: 1.5,
    transform: "translate(3819 2738.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 14,
    height: 3,
    rx: 1.5,
    transform: "translate(3819 2746.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 32,
    height: 3,
    rx: 1.5,
    transform: "translate(3801 2755.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 32,
    height: 3,
    rx: 1.5,
    transform: "translate(3801 2763.644)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextEng);
export default __webpack_public_path__ + "static/media/text-eng.68369040962988102def314bd4531e90.svg";
export { ForwardRef as ReactComponent };